function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M4.111 7.467h1.556V8.96H4.11V7.467zM4.111 10.453h1.556v1.494H4.11v-1.494zM8.778 7.467H7.222V8.96h1.556V7.467zM7.222 10.453h1.556v1.494H7.222v-1.494zM11.889 7.467h-1.556V8.96h1.556V7.467zM10.333 10.453h1.556v1.494h-1.556v-1.494z",
  fill: "#03B8DF"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.444 14.933H2.556c-.858 0-1.556-.67-1.556-1.493V2.987c0-.824.698-1.494 1.556-1.494H4.11V0h1.556v1.493h4.666V0h1.556v1.493h1.555c.858 0 1.556.67 1.556 1.494V13.44c0 .824-.698 1.493-1.556 1.493zm0-10.453V2.987H2.556V4.48h10.889zm0 1.493l.001 7.467H2.555V5.973h10.89z",
  fill: "#03B8DF"
});

var SvgCalendarIconFocus = function SvgCalendarIconFocus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgCalendarIconFocus;